/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Partner_Org_Contract_Revoke_TitleInputs */



/**
* | output |
* | --- |
* | "Withdraw approval for {orgName}?" |
*
* @param {Partner_Org_Contract_Revoke_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_revoke_title = /** @type {((inputs: Partner_Org_Contract_Revoke_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Revoke_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Freigabe für ${i?.orgName} zurückziehen?`)
	return /** @type {LocalizedString} */ (`Withdraw approval for ${i?.orgName}?`)
});